import { SortDirection, SortConfig, RowConfig, ColumnConfig } from '@/shared/types/table';

export const sortRows = <T>(
  rows: RowConfig<T>[],
  columnId: string,
  direction: SortDirection,
  columns: ColumnConfig<T>[],
): RowConfig<T>[] => {
  if (!direction) return rows;

  const column = columns.find((col) => col.id === columnId);
  if (!column) return rows;

  const sortedRows = [...rows].sort((a, b) => {
    const aValue = column.accessor
      ? typeof column.accessor === 'function'
        ? column.accessor(a)
        : a[column.accessor]
      : null;

    const bValue = column.accessor
      ? typeof column.accessor === 'function'
        ? column.accessor(b)
        : b[column.accessor]
      : null;

    if (aValue === null || aValue === undefined) return 1;
    if (bValue === null || bValue === undefined) return -1;

    let comparison: number;

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      comparison = aValue.localeCompare(bValue);
    } else if (typeof aValue === 'number' && typeof bValue === 'number') {
      comparison = aValue - bValue;
    } else if (aValue instanceof Date && bValue instanceof Date) {
      comparison = aValue.getTime() - bValue.getTime();
    } else {
      comparison = String(aValue).localeCompare(String(bValue));
    }

    return direction === 'asc' ? comparison : -comparison;
  });

  return sortedRows;
};

export const toggleSortDirection = (currentDirection: SortDirection): SortDirection => {
  if (currentDirection === null) return 'asc';
  if (currentDirection === 'asc') return 'desc';
  return null;
};

/**
 * Calcula el siguiente SortConfig al hacer clic en una columna.
 * Así onSort puede recibir el valor que aplica después del clic (evita pasar el estado anterior por la asincronía de setState).
 */
export const getNextSortConfig = (
  current: SortConfig | undefined,
  columnId: string,
): SortConfig | undefined => {
  if (current?.columnId === columnId) {
    const nextDirection = toggleSortDirection(current.direction);
    return nextDirection ? { columnId, direction: nextDirection } : undefined;
  }
  return { columnId, direction: 'asc' };
};
